import { enableProdMode, provideZoneChangeDetection, Injectable, LOCALE_ID, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';

import 'hammerjs';
import { HAMMER_GESTURE_CONFIG, HammerGestureConfig, BrowserModule, HammerModule, bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgApexchartsModule } from 'ng-apexcharts';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { MarkdownModule } from 'ngx-markdown';
import { AppComponent } from './app/app.component';
import packageJson from '../package.json';
import { registerLocaleData } from '@angular/common';
import localeNlBe from '@angular/common/locales/nl-BE'
import { provideRouter } from '@angular/router';
import { appRouterConfig } from './app/modules/routing/AppRouterConfig';

if (environment.production) {
  enableProdMode();
}

/**
 * Register nl-BE local to allow correct date, number currency, ... formatting.
 */
registerLocaleData(localeNlBe, 'nl-BE');

/**
 * HammerJS config: used for touch events
 */
 @Injectable()
export class MyHammerConfig extends HammerGestureConfig {
  override overrides = <any> {
    swipe: { direction: Hammer.DIRECTION_ALL },
    pinch: { enable: false },
    rotate: { enable: false }
  };
}

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(appRouterConfig),
    importProvidersFrom(
      BrowserModule,
      NgApexchartsModule,
      HammerModule,
      BrowserAnimationsModule,
      TranslateModule.forRoot({
        loader: provideTranslateHttpLoader({
          prefix: './assets/i18n/',
          suffix: `.json?v=${packageJson.version}`,
        }),
      }),
      MarkdownModule.forRoot()
    ),
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: MyHammerConfig
    },
    { provide: LOCALE_ID, useValue: 'nl-BE' },
    provideHttpClient(withInterceptorsFromDi())
  ]
}).catch(err => console.error(err));